import React, { useEffect, useState } from "react";
import { useLanguage } from "../context/LanguageContext";

export default function FloatingContact() {
  const { lang, contactInfo } = useLanguage();
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setMounted(true), 900);
    return () => clearTimeout(t);
  }, []);

  const phone = contactInfo.phone;
  const phoneClean = String(phone || "").replace(/\D/g, "");
  if (!phoneClean) return null;

  const waMessage = encodeURIComponent(
    lang === "ro"
      ? "Salut! Sunt interesat/ă de serviciile Social Destiny."
      : "Hi! I'm interested in Social Destiny's services."
  );
  const waLink = `https://wa.me/${phoneClean}?text=${waMessage}`;
  const waLabel = lang === "ro" ? "Scrie pe WhatsApp" : "Chat on WhatsApp";

  if (!mounted) return null;

  return (
    <div
      className="fixed bottom-[max(1.25rem,env(safe-area-inset-bottom))] left-4 z-[90] sm:bottom-6 sm:left-6"
      data-testid="floating-contact"
    >
      <a
        href={waLink}
        target="_blank"
        rel="noreferrer"
        aria-label={`${waLabel} · ${phone}`}
        className="group relative flex items-center"
        data-testid="floating-whatsapp"
      >
        <span className="relative flex h-12 w-12 items-center justify-center rounded-full bg-[#25D366] text-white shadow-[0_12px_40px_rgba(37,211,102,0.4)] transition-all duration-300 hover:scale-105 active:scale-95 sm:h-14 sm:w-14">
          <span className="absolute inset-0 rounded-full bg-[#25D366] opacity-25 animate-ping" />
          <i className="fa-brands fa-whatsapp relative text-[1.25rem] leading-none sm:text-[1.35rem]" aria-hidden />
        </span>
        <span className="ml-3 hidden whitespace-nowrap rounded-full bg-[#3e2723] px-4 py-2 text-[12px] font-semibold text-[#fbd9e5] opacity-0 shadow-lg transition-all duration-300 -translate-x-2 lg:inline-flex lg:group-hover:translate-x-0 lg:group-hover:opacity-100">
          {waLabel} · {phone}
        </span>
      </a>
    </div>
  );
}
